import React, { FC } from 'react';
import cls from 'classnames';

import CartToggle from './atoms/CartToggle';
import SearchInput from './atoms/SearchInput';
import SearchToggle from './atoms/SearchToggle';

import styles from './index.module.sass';

interface SearchAndCartProps {
  className?: {
    container?: string;
    overlay?: string;
  };
  overlaySearch: boolean;
  showSearch?: boolean;
  onClickSearchToggle: () => void;
}

const SearchAndCart: FC<SearchAndCartProps> = ({
  className,
  overlaySearch,
  showSearch = true,
  onClickSearchToggle,
}) => (
  <div className={cls( styles.container, className?.container )}>
    {showSearch && (
      <>
        <SearchToggle isActive={overlaySearch} onClick={onClickSearchToggle} />

        <div
          className={cls( styles.search, { [styles.overlay]: overlaySearch }, className?.overlay )}
        >
          <SearchInput visible={overlaySearch} />
        </div>
      </>
    )}

    <CartToggle />
  </div>
);

export default SearchAndCart;
